import { InvoiceWordExportFeatureResponseSchema, } from '@packages/types';
import { api } from '../client.js';
export function getInvoiceWordExportFeature(accountId) {
    return api(`/accounts/${accountId}/invoice-word-export`, InvoiceWordExportFeatureResponseSchema);
}
